<div class="page pt-5 self-cert-page">
	<!-- Loading -->
	<div
		*ngIf="state === 'loading'"
		class="
			d-flex
			flex-column
			align-items-center
			justify-content-center
			flex-grow-1
		"
	>
		<mat-spinner diameter="48"></mat-spinner>
		<p class="mt-4">Validating your link...</p>
	</div>

	<!-- TaxBit Form -->
	<ng-container *ngIf="state === 'form'">
		<div class="row">
			<h1 *ngIf="entityName" class="col page__title">
				Self-Certification — {{ entityName }}
			</h1>
			<mat-divider class="mb-3"></mat-divider>
		</div>
		<div>
			<bcb-taxbit-form
				[bearerToken]="bearerToken"
				(formSuccess)="onFormSuccess()"
				(formError)="onFormError($event)"
			></bcb-taxbit-form>
		</div>
	</ng-container>

	<!-- Submitting -->
	<div
		*ngIf="state === 'submitting'"
		class="
			d-flex
			flex-column
			align-items-center
			justify-content-center
			flex-grow-1
		"
	>
		<mat-spinner diameter="48"></mat-spinner>
		<p class="mt-4">Submitting your form...</p>
	</div>

	<!-- Confirmed -->
	<ng-container *ngIf="state === 'confirmed'">
		<div class="row">
			<h1 class="col page__title">Form Submitted Successfully</h1>
			<mat-divider class="mb-3"></mat-divider>
		</div>
		<div class="d-flex align-items-center mb-4">
			<img class="me-4" src="assets/svg/success.svg" alt="" width="100" />
			<p>
				Thank you for completing your self-certification. No further
				action is required.
			</p>
		</div>
		<p>
			If you require any assistance, please contact us at
			<a href="mailto:csonboarding@bcbgroup.io"
				>csonboarding@bcbgroup.io</a
			>
		</p>
	</ng-container>

	<!-- Paused for maintenance -->
	<ng-container *ngIf="state === 'paused'">
		<div class="row">
			<h1 class="col page__title">Temporarily Unavailable</h1>
			<mat-divider class="mb-3"></mat-divider>
		</div>
		<div class="d-flex align-items-center mb-4">
			<img
				class="me-4"
				src="assets/svg/in_progress.svg"
				alt=""
				width="100"
			/>
			<p>
				Self-certification is temporarily unavailable while we complete
				scheduled maintenance. Your link is still valid — please try
				again later.
			</p>
		</div>
		<p>
			If you require any assistance, please contact us at
			<a href="mailto:csonboarding@bcbgroup.io"
				>csonboarding@bcbgroup.io</a
			>
		</p>
	</ng-container>

	<!-- Error -->
	<ng-container *ngIf="state === 'error'">
		<div
			class="
				d-flex
				flex-column
				align-items-center
				justify-content-center
				flex-grow-1
			"
		>
			<img class="mb-4" src="assets/svg/error.svg" alt="" width="200" />

			<ng-container [ngSwitch]="errorReason">
				<ng-container *ngSwitchCase="'EXPIRED'">
					<h1>Link Expired</h1>
					<h3>
						Your self-certification link has expired. Please contact
						your account manager to request a new one.
					</h3>
				</ng-container>

				<ng-container *ngSwitchCase="'WRONG_STATUS'">
					<h1>Link No Longer Valid</h1>
					<h3>
						This self-certification has already been completed or is
						no longer available.
					</h3>
				</ng-container>

				<!-- The link is fine — the TaxBit form itself failed to load, so do not
				     send the client looking for a new link. -->
				<ng-container *ngSwitchCase="'SDK_ERROR'">
					<h1>Form Temporarily Unavailable</h1>
					<h3>
						We could not load the self-certification form. Your link
						is still valid, so there is no need to request a new
						one. Please try again shortly, or contact us at
						<a href="mailto:csonboarding@bcbgroup.io"
							>csonboarding@bcbgroup.io</a
						>
						if the problem continues.
					</h3>
				</ng-container>

				<ng-container *ngSwitchDefault>
					<h1>Invalid Link</h1>
					<h3>
						The link you followed is invalid. Please check your
						email for the correct link or contact us at
						<a href="mailto:csonboarding@bcbgroup.io"
							>csonboarding@bcbgroup.io</a
						>
					</h3>
				</ng-container>
			</ng-container>
		</div>
	</ng-container>
</div>
